export const satelliteScreenshotFilename = "Satellite Screenshot.jpg";

export default interface IAttachment {
    key: string;
    fileName: string;
    size: number;
    url: string;
    createdAt: Date;
}

export interface IAttachmentResponseModel {
    key: string;
    fileName: string;
    size: number;
    url: string;
    createdAt: string;
}

export function mapAttachmentResponseModel(model: IAttachmentResponseModel): IAttachment {
    return {
        key: model.key,
        fileName: model.fileName,
        size: model.size,
        url: model.url,
        createdAt: new Date(model.createdAt),
    };
}
